'use client'

import { Note } from '@vinted/web-ui'
import { v4 as uuid } from 'uuid'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { setSessionStorageItem } from '@marketplace-web/browser/browser-storage-util'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { urlWithParams } from '@marketplace-web/shared/url-util'
import { REPORT_SESSION_ID_KEY, AlertType } from '@marketplace-web/admin-alert/admin-alert-data'
import { clickEvent } from '@marketplace-web/messaging/conversation-messaging-data'

import { NEW_ADMIN_ALERT_URL } from '../../../constants/routes'

type Props = {
  conversationId: string | number | undefined
}

const ReportSuggestion = ({ conversationId }: Props) => {
  const translate = useTranslate()
  const { relativeUrl } = useBrowserNavigation()
  const { track } = useTracking()

  const reportUrl = urlWithParams(NEW_ADMIN_ALERT_URL, {
    ref_id: conversationId,
    ref_type: AlertType.Conversation,
    ref_url: relativeUrl,
  })

  const handleReportClick = () => {
    setSessionStorageItem(REPORT_SESSION_ID_KEY, uuid())

    track(
      clickEvent({
        screen: 'message_list',
        target: 'report_conversation',
        targetDetails: String(conversationId),
      }),
    )
  }

  const reportText = translate('conversation.report_suggestion.text', {
    'report-link': chunks => (
      <a key="report-link" href={reportUrl} onClick={handleReportClick}>
        {chunks}
      </a>
    ),
  })

  return <Note text={reportText} alignment={Note.Alignment.Center} styling={Note.Styling.Wide} />
}

export default ReportSuggestion
